// extracted by mini-css-extract-plugin
export default {"template":"PortalTemplate__template__hblF7"};